<template>
  <div class="login_wrap">
    <TopNav></TopNav>
    <div class="login_form">
      <img class="tzx_logo" src="../../assets/login_logo.png">
      <p class="tzx_site"><a class="a_link" :href="advSite">{{upperSite}}</a></p>
      <p class="custom_made">— 专属于您的私人订制 —</p>
      <LoginInput
        class="form_item"
        name="phone"
        auto="new-phone"
        placeholder="手机号码"
        maxlength="11"
        v-model="form.phoneNumber"
        @input="inputPhone">
        <template #default>
          <i class="iconfont icon-dengluzhuce-zhanghao icon_user"></i>
        </template>
      </LoginInput>
      <LoginInput
        class="form_item"
        name="pwd"
        placeholder="密码"
        :type="showPwd ? 'text' : 'password'"
        v-model="form.password"
        @input="inputPwd"
        @enter="loginSubmit">
        <template #default>
          <img class="icon_pwd" :src="showPwd ? pwdShow : pwdHide" @click="togglePwd">
        </template>
      </LoginInput>
      <div class="login_btn" @click="loginSubmit">登录</div>
      <div class="other_btn">
        <div class="go_regist" @click="goUrl('/registry')">立即注册</div>
        <div class="find_pwd" @click="goUrl('/registry', { type: 'password' })">忘记密码</div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TheTopNav'
import LoginInput from '@/components/LoginInput'
import { pwdLogin } from '@/utils/customerApi'
import pwdShow from '@/assets/login_pwd_show.png'
import pwdHide from '@/assets/login_pwd_hide.png'
import { phoneReg } from '@/utils/fn'

export default {
  name: 'Login',
  components: { TopNav, LoginInput },
  data () {
    const site = window.location.origin
    return {
      advSite: site,
      pwdHide,
      pwdShow,
      showPwd: false,
      form: {
        phoneNumber: '',
        password: ''
      }
    }
  },
  computed: {
    upperSite () {
      return this.advSite.toUpperCase()
    }
  },
  methods: {
    inputPhone (v) {
      this.$nextTick(() => {
        this.form.phoneNumber = v.replace(/[^\d]/g, '')
      })
    },
    inputPwd (v) {
      this.$nextTick(() => {
        this.form.password = v.replace(/[^\da-zA-Z]/g, '')
      })
    },
    togglePwd () {
      this.showPwd = !this.showPwd
    },
    async loginSubmit () {
      const { phoneNumber, password } = this.form
      if (!phoneReg.test(phoneNumber)) return this.$message.error('请输入正确的手机号')
      // if (!passwordReg.test(password)) return this.$message.error('请输入正确的密码')
      if (!password.trim()) return this.$message.error('请输入登录密码')
      const param = await this.encryptorProto({ password })
      if (param) {
        param.phoneNumber = phoneNumber
        param.loginType = 1 // 1:账号密码登录 2:验证码登录
        const res = await pwdLogin(param)
        if (res && res.code === 0 && res.data) {
          if (res.data.token) localStorage.setItem('user_ticket', res.data.token)
          localStorage.setItem('TzxUid', res.data.id)
          this.$store.commit('customer/setUserInfo', { ...res.data })
          this.goUrl('/home')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login_wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('../../assets/login_bg.png') no-repeat;
  background-size: cover;
  background-position: center center;
  overflow-y: auto;
}
.login_form {
  position: absolute;
  left: 50%;
  top: 50%;
  background: #fff;
  border-radius: 20px;
  color: #282729;
  width: 960px;
  height: 680px;
  margin-top: 50px;
  padding-top: 70px;
  transform: translate(-50%, -50%);
  text-align: center;
  .tzx_logo {
    width: 113px;
    object-fit: scale-down;
  }
  .tzx_site {
    line-height: 20px;
    margin-top: 6px;
    .a_link {
      color: #282729;
    }
  }
  .custom_made {
    color: #999;
    font-size: 18px;
    line-height: 20px;
    margin: 30px 0;
  }
  .form_item {
    margin: 0 auto;
    &:not(:last-child) {
      margin-bottom: 30px;
    }
    .icon_user {
      font-size: 16px;
      position: absolute;
      right: 0;
      bottom: 8px;
    }
    .icon_pwd {
      cursor: pointer;
      position: absolute;
      right: 0;
      bottom: 8px;
      width: 16px;
    }
  }
  .login_btn {
    cursor: pointer;
    background: $main-gradient;
    border-radius: 4px;
    color: #fff;
    font-size: 18px;
    width: 360px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
  }
  .other_btn {
    width: 360px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    line-height: 20px;
    margin: 10px auto 0;
    .go_regist {
      cursor: pointer;
      color: #ff3973;
    }
    .find_pwd {
      cursor: pointer;
      color: #666;
    }
  }
}
</style>
